const tabSystem = document.querySelectorAll('.js-tab-system');

tabSystem.forEach((system) => {
    const buttons = system.querySelectorAll(`.tab-header[data-level="${system.dataset.level}"] > .js-tab-button`);
    const tabs = system.querySelectorAll(`.tab-container[data-level="${system.dataset.level}"] > .js-tab`);
    console.log(tabs);

    buttons.forEach(button => {
        button.addEventListener('click', (e) => {
            buttons.forEach(b => {
                if (e.target == b) {
                    b.classList.add('active')
                } else {
                    b.classList.remove('active')
                }
            })
            tabs.forEach(t => {
                if (t.dataset.type == e.target.dataset.type) {
                    t.classList.add('active')
                } else {
                    t.classList.remove('active')
                }
            })
        })
    })
})

const quickLinks = document.querySelectorAll('.js-quick-links');

if (quickLinks.length > 1) {
    quickLinks.forEach((el, i) => {
        if (i != 0) {
            el.innerHTML = quickLinks[0].innerHTML; 
        }
    })
}
    
